import SiafLiteApiRepository from "../../external/siafLiteApi";

class MdfeCiotService {
  constructor() {
    this.urlBase = "/faturamento/mdfe-ciot";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  cadastrar(data) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(data);
  }
}

export default MdfeCiotService;